import React from 'react';

export default function CTASection() {
  return (
    <div className="bg-gradient-to-br from-gray-900 to-black py-24" id="contact">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Mike's profile */}
          <div className="text-center lg:text-left">
            <div className="mb-8 relative">
              {/* Animated background glow */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-emerald-500 rounded-full blur-3xl opacity-20 animate-pulse"></div>
              <img
                src="/mike-pantouvakis.jpg"
                alt="Mike Pantouvakis"
                className="relative w-64 h-64 rounded-full mx-auto lg:mx-0 object-cover shadow-2xl border-4 border-white/10"
                onError={(e) => {
                  e.target.onerror = null;
                  // Fallback to placeholder
                  e.target.src =
                    "data:image/svg+xml,%3Csvg width='256' height='256' viewBox='0 0 256 256' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='256' height='256' rx='128' fill='url(%23gradient)'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='white' font-size='72' font-weight='bold' font-family='system-ui'%3EMP%3C/text%3E%3Cdefs%3E%3ClinearGradient id='gradient' x1='0' y1='0' x2='256' y2='256'%3E%3Cstop offset='0%25' stop-color='%231E40AF'/%3E%3Cstop offset='100%25' stop-color='%23059669'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E";
                }}
              />
            </div>
            <h3 className="text-4xl font-bold text-white mb-2">Mike Pantouvakis</h3>
            <p className="text-2xl text-amiva-accent mb-4">Founder & Managing Principal</p>
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
              "We've helped hundrends of business owners maximize their exit value. Let's discuss how we
              can achieve the same for you."
            </p>
            <div className="flex flex-col sm:flex-row gap-4 lg:justify-start justify-center">
              <div className="flex items-center gap-2 text-gray-400">
                <svg className="w-5 h-5 text-amiva-accent" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>50+ Successful Engagements</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400">
                <svg className="w-5 h-5 text-amiva-accent" fill="currentColor" viewBox="0 0 20 20">
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>$500M+ in Transactions</span>
              </div>
            </div>
          </div>

          {/* Right side - Meeting booking */}
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 lg:p-10 border border-white/10">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4 text-center">
              Ready to Explore Your Options?
            </h2>
            <p className="text-lg text-gray-300 mb-8 text-center">
              Get a confidential discussion about your business's true value and exit opportunities.
            </p>

            <div className="space-y-4">
              <a
                href="https://app.usemotion.com/meet/mike-pantouvakis/acquisition-discussion"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-amiva-gradient text-white px-8 py-5 rounded-2xl font-semibold text-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 text-center"
              >
                Book Your Free Consultation
              </a>

              <div className="text-center">
                <p className="text-gray-400 mb-2">or call directly</p>
                <a
                  href={`tel:${require('../../config/appConfig').appConfig.site.contactPhone}`}
                  className="text-2xl font-bold text-white hover:text-amiva-accent transition-colors"
                >
                  {require('../../config/appConfig').appConfig.site.contactPhone}
                </a>
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-white/10">
              <div className="flex items-center justify-center gap-6 text-sm text-gray-400">
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>100% Confidential</span>
                </div>
                <div className="flex items-center gap-2">
                  <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>No Obligations</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust indicators */}
        <div className="mt-16 pt-16 border-t border-white/10">
          <p className="text-center text-gray-500 mb-8 text-sm uppercase tracking-wider">
            Our Track Record Speaks for Itself
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
            <div className="text-center group">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400 mb-2 transition-all duration-300 group-hover:scale-110">
                3.5
              </div>
              <div className="text-sm text-gray-400">Avg Competing Offers</div>
            </div>
            <div className="text-center group">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400 mb-2 transition-all duration-300 group-hover:scale-110">
                35%
              </div>
              <div className="text-sm text-gray-400">Above Initial Offer</div>
            </div>
            <div className="text-center group">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400 mb-2 transition-all duration-300 group-hover:scale-110">
                6 mo
              </div>
              <div className="text-sm text-gray-400">Avg Time to Close</div>
            </div>
            <div className="text-center group">
              <div className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400 mb-2 transition-all duration-300 group-hover:scale-110">
                24/7
              </div>
              <div className="text-sm text-gray-400">Client Support</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
